import branch from 'branch-sdk'

export function setIdentity(guid) {
  return dispatch => {
    branch.setIdentity(guid)
    dispatch(fetchCredits())
  }
}

export function fetchCredits() {
  return dispatch => {
    branch.credits((err, data) => {
      if (!err) {
        dispatch({ type: 'SET_CREDITS', data })
      } else {
        console.log('Error fething credits', err)
        dispatch({ type: 'SET_CREDITS', data: { default: 0 } })
      }
    })
  }
}

export function applyPromoCode(code) {
  return dispatch => new Promise((res, rej) => {
    branch.applyCode(code, (err, data) => {
      if (err) {
        dispatch(fetchCredits())
        rej({ response: { data: { errors: {
          code: 'Sorry, that promo code is invalid.'
        }}}})
      } else {
        dispatch({ type: 'SET_FLASH', flash: {
          type: 'success',
          message: 'Promo code successfully applied to your delivery',
        }})
        dispatch(fetchCredits())
        res()
      }
    })
  })
}